import { toggleClass, hasClass } from "../utils/_class-handlers";
import { animate, stagger } from 'animejs';
import NavigationScrollHandler from '../utils/_navigation-scroll';

export default class Navigation {

	ready() {

		const MAIN_HEADER = document.getElementById('main_header');
		
		if (MAIN_HEADER) {

			new ResponsiveNavigation('main_nav', 'navigation-toggle');

			new NavigationScrollHandler({
				scrollDistance: 80,
				headerElement: MAIN_HEADER,
				onEnter: () => {
					if (!document.body.classList.contains('header-scrolled')) {
						document.body.classList.add('header-scrolled');
					}
				},
				onExit: () => {
					if (document.body.classList.contains('header-scrolled')) {
						document.body.classList.remove('header-scrolled');
					}
				}
			});
		}
	}

	getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
}

class ResponsiveNavigation {

	constructor(ID, TOGGLE_ID) {
		this.ID = ID;
		this.TOGGLE_ID = TOGGLE_ID;
		this.BREAKPOINT = 1160;
        this.canToggle = true;

		// Elements
		this.NAV = document.getElementById(ID);
		this.MAIN_HEADER = document.getElementById('main_header');
		this.NAV_OVERLAY = document.getElementById('overlay');
		this.NAV_TOGGLE = document.getElementById(TOGGLE_ID);

		this.appendDropdownArrows();
		this.bindEventHandlers();

		// Testing
		// this.toggleNavigation();
    }

    bindEventHandlers() {

		 // close menu when overlay is clicked
        this.NAV_OVERLAY.addEventListener('click', this.closeNavigation.bind(this));

		// close nav if submenu item is current
		this.submenuOnClick();

        // toggle nav
		this.NAV_TOGGLE.addEventListener('click', () => {
			this.toggleNavigation();
		});

		// click on escape
		document.addEventListener('keydown', (e) => {
            if (e.keyCode === 27) {
				this.closeNavigation();
            }
		});
    }

	toggleNavigation() {

		// Check if toggleable 
		this.toggleable();

		// Toggle elements
		this.NAV_TOGGLE.classList.toggle('open');
		this.NAV.classList.toggle('open');
		this.NAV_OVERLAY.classList.toggle('show');
		document.body.classList.toggle('nav-open');
	}

	// Check if menu is toggleable
	toggleable() {
		if (!this.canToggle) return;
		this.canToggle = false;
		setTimeout(() => { this.canToggle = true; }, 200);
	}

	// Close the navigation
	closeNavigation() {
		this.NAV_TOGGLE.classList.remove('open');
		this.NAV.classList.remove('open');
		this.NAV_OVERLAY.classList.remove('show');
        document.body.classList.remove('nav-open');
	}

	// Append dropdown arrows for items with children
	appendDropdownArrows() {

		const MENUS_WITH_CHILDREN = document.querySelectorAll('.menu-item-has-children, .has-solutions-submenu');

		for (let i = 0; i < MENUS_WITH_CHILDREN.length; i++) {

			const MENU_ITEM = MENUS_WITH_CHILDREN[i];
			const DROPDOWN_ELEMENT = document.createElement('div');

			DROPDOWN_ELEMENT.className = 'dropdown-arrow';
			DROPDOWN_ELEMENT.addEventListener('click', this.toggleSubMenu.bind(this));

			MENU_ITEM.appendChild(DROPDOWN_ELEMENT);
		}
	}

	// Close menu on submenu item click
	submenuOnClick() {

		const ALL_MENU_ITEMS = document.querySelectorAll('#menu-main-menu .current_page_item li');

		for (let i = 0; i < ALL_MENU_ITEMS.length; i++) {

			const MENU_ITEM = ALL_MENU_ITEMS[i];

			MENU_ITEM.addEventListener('click', () => {
				this.closeNavigation();
			});
		}
	}

	// Toggle submenu
	toggleSubMenu(e) {

		if (this.getScreenWidth() <= 1160) {

			const THIS = e.target;
			const MENU_WRAP = THIS.parentNode;
			const SUBMENU_WRAP = MENU_WRAP.querySelector('.sub-menu');
			const SUBMENU_ITEMS = SUBMENU_WRAP.querySelectorAll('.menu-item');
	
			toggleClass(MENU_WRAP, 'menu-open');
	
			if (hasClass(MENU_WRAP, 'menu-open')) {
				this.subMenuAnimation(SUBMENU_ITEMS);
			} else {
				this.hideSubMenuItems(SUBMENU_ITEMS);
			}
		}
	}

	subMenuAnimation(targetElements) {
		animate(targetElements, {
			translateX: ['-50px', 0],
			opacity: [0, 1],
			ease: 'outElastic(1, .5)',
			duration: 700,
			delay: stagger(75)
		})
	}

	hideSubMenuItems(targetElements) {
		for (let i = 0; i < targetElements.length; i++) {
			const SUBMENU_ITEM = targetElements[i];
			SUBMENU_ITEM.style.transform = 'translateX(-100%)';
		}
	}

	/************************************************
	 * Helpers
	 ***********************************************/

    getScreenWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }

    getScrollY() {
        return (window.pageYOffset || document.documentElement.scrollTop)  - (document.documentElement.clientTop || 0);
    }

    getHeaderHeight() {
        return this.MAIN_HEADER.getBoundingClientRect().height;
	}
}